// client/src/services/walletService.js
import axios from '../utils/axiosConfig';

export const getWallet = () => axios.get('/wallet').then(r => r.data);
export const listBanks = () => axios.get('/wallet/banks').then(r => r.data.banks);
export const previewBankAccount = (accountNumber, bankCode) =>
  axios.get('/wallet/bank-account/preview', { params: { accountNumber, bankCode } }).then(r => r.data.accountName);
export const verifyAndSaveBankAccount = (data) => axios.post('/wallet/bank-account', data).then(r => r.data.bankAccount);
export const initFunding = (amount) => axios.get('/wallet/fund', { params: { amount } }).then(r => r.data);
export const verifyFunding = (reference) => axios.post('/wallet/fund/verify', { reference }).then(r => r.data);
export const requestWithdrawal = (amount) => axios.post('/wallet/withdraw', { amount }).then(r => r.data.request);
export const getMyWithdrawals = () => axios.get('/wallet/withdrawals').then(r => r.data.requests);
